(function () {
  // Bathroom City: guard against this file being included more than once on a page
  if (window.__bcBundleFinanceLoaded) return;
  window.__bcBundleFinanceLoaded = true;

  var FINANCE_MIN_PRICE = 700;

  function novunaMonthlyPayment(totalPrice, deposit = 0) {
    const APR = 0.139;
    const TERM_MONTHS = 36;
    const principal = totalPrice - deposit;
    const monthlyRate = Math.pow(1 + APR, 1 / 12) - 1;
    const factor = Math.pow(1 + monthlyRate, TERM_MONTHS);
    const monthly = principal * monthlyRate * factor / (factor - 1);
    return Math.round(monthly * 100) / 100;
  }

  function formatGBP(value) {
    return '£' + value.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function parseFirstPrice(container) {
    const clone = container.cloneNode(true);
    clone.querySelectorAll('s').forEach(el => el.remove());
    clone.querySelectorAll('.bc-finance-inline').forEach(el => el.remove());
    const match = clone.textContent.match(/£\s?([\d,]+\.\d{2})/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : null;
  }

  // Bathroom City: some Sparrow offers don't render a <s> around the compare-at price
  // (only plain text, e.g. "Claim Offer • £554.38 £615.98"). Normalise those so every
  // offer shows the same struck-through styling as the ones Sparrow already formats.
  function ensureStrikethrough(el) {
    if (el.querySelector('s')) return; // Sparrow already rendered a genuine strikethrough

    var re = /(£[\d,]+\.\d{2})(\s+)(£[\d,]+\.\d{2})/;

    Array.from(el.childNodes).forEach(function (node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      var match = node.textContent.match(re);
      if (!match) return;

      var price1 = parseFloat(match[1].replace(/[£,]/g, ''));
      var price2 = parseFloat(match[3].replace(/[£,]/g, ''));
      if (!(price2 > price1)) return; // only strike through a genuine discount

      var before = node.textContent.slice(0, match.index);
      var after = node.textContent.slice(match.index + match[0].length);

      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(before + match[1] + match[2]));
      var s = document.createElement('s');
      s.textContent = match[3];
      frag.appendChild(s);
      if (after) frag.appendChild(document.createTextNode(after));

      node.replaceWith(frag);
    });
  }

  // Bathroom City: some Sparrow offers wrap their price text in .btn-text-content,
  // others render the exact same content as plain text directly inside the button
  // (which is itself a flex container with its own gap - appending our finance tag
  // straight into it stacks that gap with our own margin, producing a bigger gap
  // than the offers that already have the wrapper span). Normalise both formats to
  // the same wrapped structure so spacing is identical everywhere.
  function ensureTextWrapper(btn) {
    let textSpan = btn.querySelector('.btn-text-content');
    if (textSpan) return textSpan;

    textSpan = document.createElement('span');
    textSpan.className = 'btn-text-content';
    while (btn.firstChild) {
      textSpan.appendChild(btn.firstChild);
    }
    btn.appendChild(textSpan);
    return textSpan;
  }

  function updateButton(textSpan) {
    ensureStrikethrough(textSpan);

    const total = parseFirstPrice(textSpan);
    if (total === null) return;

    const monthly = novunaMonthlyPayment(total);
    const label = `or from £${monthly.toFixed(2)}/mo`;

    let tag = textSpan.querySelector('.bc-finance-inline');
    if (tag && tag.dataset.value === label) return; // already correct, stop here

    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'bc-finance-inline';
      tag.style.marginLeft = '8px';
      tag.style.opacity = '0.85';
      tag.style.fontWeight = 'bold';
      textSpan.appendChild(tag);
    }
    tag.dataset.value = label;
    tag.textContent = label;
  }

  function watchButton(btn) {
    const textSpan = ensureTextWrapper(btn);
    if (textSpan.dataset.bcWatched) return;
    textSpan.dataset.bcWatched = 'true';

    updateButton(textSpan);
    const obs = new MutationObserver(() => updateButton(textSpan));
    obs.observe(textSpan, { childList: true, characterData: true, subtree: true });
    obs.observe(btn, { attributes: true, attributeFilter: ['data-selected-items'] });
  }

  function updateMainPrice(priceEl, row) {
    const match = priceEl.textContent.match(/£\s?([\d,]+\.\d{2})/);
    let tag = row.querySelector('.bc-price-finance-inline');

    if (!match) {
      if (tag) tag.remove();
      return;
    }

    const price = parseFloat(match[1].replace(/,/g, ''));

    if (price <= FINANCE_MIN_PRICE) {
      if (tag) tag.remove();
      return;
    }

    const monthly = novunaMonthlyPayment(price);
    const label = `or from £${monthly.toFixed(2)}/month`;

    if (tag && tag.dataset.value === label) return; // already correct, stop here

    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'bc-price-finance-inline text-grey-dark';
      tag.style.opacity = '0.85';
      row.appendChild(tag);
    }
    tag.dataset.value = label;
    tag.textContent = label;
  }

  function watchMainPrice() {
    const priceEl = document.querySelector('.product-details .product-price__normal[data-ref="productPrice"]');
    if (!priceEl) return;

    const row = priceEl.closest('[itemprop="offers"]') || priceEl.parentElement;
    if (!row || row.dataset.bcPriceWatched) return;
    row.dataset.bcPriceWatched = 'true';

    updateMainPrice(priceEl, row);
    const obs = new MutationObserver(() => updateMainPrice(priceEl, row));
    obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  // Bathroom City: Bundle Offer tiles in collection grids show the same Novuna
  // "or from £x/month" figure as the product page, on its own line under the price.
  // Uses the same calculation and the same minimum price as the product page.
  function updateCardPrice(priceEl, tile) {
    const match = priceEl.textContent.match(/£\s?([\d,]+\.\d{2})/);
    let tag = tile.querySelector('.bc-card-finance');

    if (!match) {
      if (tag) tag.remove();
      return;
    }

    const price = parseFloat(match[1].replace(/,/g, ''));

    if (price <= FINANCE_MIN_PRICE) {
      if (tag) tag.remove();
      return;
    }

    const monthly = novunaMonthlyPayment(price);
    const value = monthly.toFixed(2);
    if (tag && tag.dataset.value === value) return;

    if (!tag) {
      const row = priceEl.closest('[itemprop="offers"]') || priceEl.parentElement;
      tag = document.createElement('p');
      tag.className = 'bc-card-finance';
      row.insertAdjacentElement('afterend', tag);
    }
    tag.dataset.value = value;
    tag.textContent = 'or from ';
    const strong = document.createElement('strong');
    strong.textContent = formatGBP(monthly) + '/month';
    tag.appendChild(strong);
  }

  function watchCardPrices() {
    document.querySelectorAll('.bc-bundle-tile [data-ref="productPrice"]').forEach(function (priceEl) {
      const tile = priceEl.closest('.bc-bundle-tile');
      if (!tile || tile.dataset.bcFinanceWatched) return;
      tile.dataset.bcFinanceWatched = 'true';
      updateCardPrice(priceEl, tile);
    });
  }

  function scan() {
    document.querySelectorAll('.upsell-claim-btn').forEach(watchButton);
    watchMainPrice();
    watchCardPrices();
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
